import { render, staticRenderFns } from "./OrgAccreditation.vue?vue&type=template&id=460d0449&"
import script from "./OrgAccreditation.vue?vue&type=script&lang=js&"
export * from "./OrgAccreditation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports